import { useQuery } from '@tanstack/react-query';

import {
  getPendingReviews,
  getTradeReviewHistory,
  getWeeklyReview,
  listTradeReviews,
  listWeeklyReviews,
} from '../../lib/api/endpoints';

export const reviewKeys = {
  all: ['reviews'] as const,
  pending: () => [...reviewKeys.all, 'pending'] as const,
  list: (status: 'pending' | 'submitted' | 'all', symbol?: string) =>
    [...reviewKeys.all, 'list', status, symbol ?? ''] as const,
  history: (tradeId: string | null) => [...reviewKeys.all, 'history', tradeId] as const,
  weekly: () => [...reviewKeys.all, 'weekly'] as const,
  weeklyDetail: (weekStart: string | null) => [...reviewKeys.weekly(), weekStart] as const,
};

export function usePendingReviews() {
  return useQuery({
    queryKey: reviewKeys.pending(),
    queryFn: getPendingReviews,
  });
}

export function useReviewsList(status: 'pending' | 'submitted' | 'all', symbol?: string) {
  return useQuery({
    queryKey: reviewKeys.list(status, symbol),
    queryFn: () => listTradeReviews({ status, ...(symbol ? { symbol } : {}) }),
  });
}

export function useReviewHistory(tradeId: string | null) {
  return useQuery({
    queryKey: reviewKeys.history(tradeId),
    queryFn: () => getTradeReviewHistory(tradeId ?? ''),
    enabled: tradeId !== null,
  });
}

export function useWeeklyReviews() {
  return useQuery({
    queryKey: reviewKeys.weekly(),
    queryFn: listWeeklyReviews,
  });
}

export function useWeeklyReview(weekStart: string | null) {
  return useQuery({
    queryKey: reviewKeys.weeklyDetail(weekStart),
    queryFn: () => getWeeklyReview(weekStart ?? ''),
    enabled: Boolean(weekStart),
  });
}
